module.exports = __webpack_public_path__ + "static/media/qualification-2.4aecadc5.svg";